"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionSelector = void 0;
const sessionSelector = (state) => state.session;
exports.sessionSelector = sessionSelector;
//# sourceMappingURL=session.js.map